var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpened
    ? _c(
        "transition-group",
        { attrs: { name: "c-modal-fade", appear: "" } },
        [
          _c("c-modal-mask", {
            key: _vm.actionText + "mask",
            attrs: { show: "" },
            on: {
              close: function($event) {
                return _vm.emitClose()
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              key: _vm.name + "modal",
              ref: "cmodal",
              class: _vm.classes,
              attrs: { "data-cy": "cmodal" }
            },
            [
              _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
              _vm._v(" "),
              !_vm.hideClose
                ? _c("c-button", {
                    staticClass: "close",
                    attrs: {
                      size: "lg",
                      icon: "cross",
                      "data-cy": "close-modal-button",
                      primary: ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.emitClose()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.actionText && !_vm.hideAction
                ? _c(
                    "c-button",
                    {
                      staticClass: "modal-action-button",
                      attrs: {
                        "data-cy": "modal-action-button",
                        "icon-size": "10",
                        size: "lg",
                        block: !_vm.isDesktop,
                        primary: _vm.isDesktop,
                        icon: _vm.actionIcon,
                        to: _vm.actionExternalLink || null,
                        external: !!_vm.actionExternalLink,
                        target: _vm.actionExternalTarget,
                        download: _vm.actionExternalDownload || null,
                        disabled: _vm.actionDisabled,
                        loading: _vm.actionLoading
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("action")
                        }
                      }
                    },
                    [_vm._v("\n      " + _vm._s(_vm.actionText) + "\n    ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bca8d60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bca8d60","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CComponents/CModal.vue
// module id = 2209
// module chunks = 1610